import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { VuexAction } from '@andromeda/types';
import {
    SET_GO_TO_CART_OPEN,
    GET_KROGER_AUTH_CONFIG,
} from '@andromeda/affiliate-data-access-kroger';
import { MUT_SEND_TELEMTRY } from '@andromeda/affiliate-data-access-walmart';
import {
    AuthOnBehalfOfConfig,
    MercuryRetailer,
    Offer,
} from '@andromeda/polaris-data-access-products';
import { RetailerLocation } from '@andromeda/shopping-cart-data-access-store';
import walmartCheckout from './mixins/walmart';
import KrogerCheckout from './mixins/kroger';
import targetCheckout from './mixins/target';
import GoToCart from './components/go-to-cart/GoToCart';
import IProductSlot from '../models/ProductSlot';

@Component({
    components: {
        GoToCart,
    },
})

export default class CheckoutButton extends Vue {
    @Prop({ required: true }) selectedRetailer!: RetailerLocation;

    @Prop({ required: true }) selectedProducts!: IProductSlot<Offer>[];

    @Prop({ required: false }) isDefault!: boolean;

    @Prop({ required: false }) getPromotionRetailer!: string;

    @Prop({ required: false }) price!: string;

    @Prop({ required: false }) getSessionId!: string;

    @Prop({ required: false }) getPromotionId!: string;

    @Getter(GET_KROGER_AUTH_CONFIG) authConfig!: AuthOnBehalfOfConfig;

    @Action(SET_GO_TO_CART_OPEN) setGoToCartOpen!: VuexAction<boolean>;

    @Prop({ required: false }) subId1!: string;

    @Prop({ required: false }) subId2!: string;

    @Prop({ required: false }) smToken!: string;

    private krogerCheckout: KrogerCheckout | null = null;


    handleClick() {
        if (this.selectedRetailer.retailer === 'wmt' || this.getPromotionRetailer === 'walmart') {
            walmartCheckout(this.selectedRetailer, this.selectedProducts, this.subId1, this.subId2, this.smToken);
            this.$store.commit(MUT_SEND_TELEMTRY);
        } if (this.selectedRetailer.retailer === 'tgt' || this.getPromotionRetailer === 'target') {
            targetCheckout(this.selectedRetailer, this.selectedProducts);
            this.$store.commit(MUT_SEND_TELEMTRY);
        } if (this.selectedRetailer.retailer === 'kro' || this.getPromotionRetailer === 'kroger') {
            if (!this.krogerCheckout && !this.isDefault) {
                this.krogerCheckout = new KrogerCheckout(this.isDefault, this.selectedRetailer, this.selectedProducts, this.authConfig, this.onKroCartCreated, this.onKroCartError);
            } else {
                this.krogerCheckout = new KrogerCheckout(this.isDefault, {
                    retailer: MercuryRetailer.KROGER,
                    id: '',
                    accessPointId: '',
                    fulfillmentStoreId: '',
                    chain: '',
                    logo: '',
                    url: '',
                    address: {
                        street: '', city: '', state: '', zipCode: '', distance: '',
                    },
                }, [], this.authConfig, this.onKroCartCreated, this.onKroCartError);
            }
            this.krogerCheckout.handleClick();
            this.$store.commit(MUT_SEND_TELEMTRY);
        }
    }

    private onKroCartCreated = (cartUrl: string) => {
        const self = this;
        self.setGoToCartOpen(true);
    }

    private onKroCartError = () => {
        console.log('Error');
    }

    get useWalmart(): boolean {
        return this.selectedRetailer.retailer === MercuryRetailer.WALMART;
    }

    get useKroger(): boolean {
        return this.selectedRetailer.retailer === MercuryRetailer.KROGER;
    }

    get buttonColor() {
        if (this.getPromotionRetailer !== 'walmart') {
            return (this.getPromotionRetailer === 'kroger') ? '#3266b0 !important' : 'red !important';
        }
        return '#FFB81C !important';
    }

    get textColor() {
        if (this.getPromotionRetailer !== 'walmart') {
            return (this.getPromotionRetailer === 'kroger') ? 'white !important' : 'white !important';
        }
        return 'black !important';
    }
}
